import { Autocomplete, Chip, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import style from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import globalStyles from "../../../../../assets/styles/global.module.scss"
import workflowStyle from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss';
import workflowCreateStyles from "../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss" 
import waCampaignStyles from "../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"; 
import textAreaStyles from '../../../../../assets/styles/componentStyles/templates.module.scss'
import Required from '../../../../utility/required';
import { useIntentStore } from '../../../../../store/intentStore';
import { customVariableDataInterface, intent, intentConfigurationPayload } from '../../../../../models/axiosModel';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext';
import { isCurrentViewVersionPublished } from '../../utilityFunctions';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import HierarchicalIntentAutocomplete from './heirarchicalIntentAutocomplete';
import { checkConditionValidation, emptyConditionGroupObj, emptyCustomVariableConditionObj, getCustomVariableById, getDefaultValueOfIntentConfigurationPayload, getOperatorTypeById, operatorTypesWithEmptyValue } from '../../flowBuilderConstants';
import { useFlowBuilderStore } from '../../../../../store/flowBuilderStore';
import { operatorType } from '../../../../../models/flowBuilderTypes';
import CloseIcon from '@mui/icons-material/Close';
import GlobalButton from '../../../../utility/globalButton/button';
import PrimaryIOSSwitch from '../../../../utility/switch/primaryIOSSwitch';
import RefreshIcon from '@mui/icons-material/Refresh';
import GlobalTooltip from '../../../../utility/tooltip/globalTooltip';

interface IntentConfigurationPopupProps {
    setFlagIntentPopup: React.Dispatch<React.SetStateAction<boolean>>,
    selectedActionIntent: any,
    selectedIntent: intentConfigurationPayload | null, 
} 

interface IntentOption {
  label: string;
  value: string;
}

type CombinedUpdateType =
  | { type: "variable"; value: customVariableDataInterface | null }
  | { type: "operator"; value: operatorType | null }
  | { type: "value"; value: string }
  | { type: "save additional info"; value: customVariableDataInterface | null }
  | { type: "flag duplicate"; value: string }
  | { type: "condition switch";  value: boolean};

type CombinedUpdateValueType = "operator" | "variable" | "value" | "save additional info" | "flag duplicate" | "freesolo value" | "condition switch";

const IntentConfigurationPopup: React.FC<IntentConfigurationPopupProps> = (props) => {
    
    const { setFlagIntentPopup, selectedActionIntent, selectedIntent } = props;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload 
    const { currentActiveStaticWorkflow} = useContext(WorkflowContext) as WorkflowContextPayload;
    const { nodes, setNodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig, operatorList, getOperatorTypeApi } = useContext(FlowBuilderContext) as FlowBuilderContextPayload 
    
    const intentDataList = useIntentStore((store) => store.intentDataList);
    const getAnalyticsIntentApiCall = useIntentStore((store) => store.getAnalyticsIntentApiCall)
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)

    const [payload, setPayload] = useState<intentConfigurationPayload>(getDefaultValueOfIntentConfigurationPayload(selectedIntent));
    const [typedConditionValue, setTypedConditionValue] = useState<string>("");
    const [flagSameIntentExist, setFlagSameIntentExist] = useState<boolean>(false);

    const getAnalyticsIntentApi = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getAnalyticsIntentApiCall();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getOperatorTypeApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getOperatorTypeApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!intentDataList){
            getAnalyticsIntentApi(); 
        }
        if (!operatorList) {
            getOperatorTypeApiCall();
        }
    }, []);

    const onChangeOfFields = ({ type, value }: CombinedUpdateType) => {
        setPayload((prev) => {
            let newPayload = { ...prev };
            const baseConditions = prev?.condition_group ? prev?.condition_group?.custom_variable_conditions : emptyCustomVariableConditionObj;
            let updatedConditions = baseConditions;

            switch (type) {
                case "variable":
                    updatedConditions = {
                        ...baseConditions,
                        chatbot_custom_variable_configuration_id:
                            value ? value.chatbot_custom_variable_configuration_id : "",
                    };
                    break;

                case "operator": {
                    const opVal = value as operatorType | null;

                    updatedConditions = {
                        ...baseConditions,
                        operator_type_id: opVal ? opVal.operator_type_id : "",
                        operator_type_name: opVal ? opVal.operator_type_name : "",
                    };

                    // Empty value operators
                    if (opVal && operatorTypesWithEmptyValue.includes(opVal.operator_type_name)) {
                        updatedConditions.condition_value = "";
                    }
                    break;
                }

                case "value":
                    updatedConditions = {
                        ...baseConditions,
                        condition_value: value as string,
                    };
                    break;
                
            case "condition switch":
                    return {
                        ...newPayload,
                        condition_group: value ? emptyConditionGroupObj : null,
                    }
                
                case "save additional info":
                    return {
                        ...newPayload,
                        chatbot_custom_variable_configuration_id:
                            value ? value.chatbot_custom_variable_configuration_id : "",
                        chatbot_custom_variable_name:
                            value ? value.chatbot_custom_variable_name : "",
                    };

                case "flag duplicate":
                    return {
                        ...newPayload,
                        flag_duplicate: value === "true",
                    };
            }

            return {
                ...newPayload,
                condition_group: {
                    ...(newPayload?.condition_group ?? emptyConditionGroupObj),
                    custom_variable_conditions: updatedConditions,
                },
            };
        }); 

        setFlagSameIntentExist(false);
    };

    const getValueOfFields = (type: CombinedUpdateValueType) => {
        const { condition_group } = payload;
        switch(type) {
            case "operator":
                return getOperatorTypeById(operatorList, condition_group?.custom_variable_conditions?.operator_type_id);
            case "variable":
                return getCustomVariableById(customVariableList, condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id) ?? null;
            case "value": 
                return condition_group?.custom_variable_conditions?.condition_value || "";
            case "save additional info": 
                return getCustomVariableById(customVariableList, payload?.chatbot_custom_variable_configuration_id) ?? null;
            case "flag duplicate":
                return payload?.flag_duplicate;
            case "freesolo value": 
                return (condition_group?.custom_variable_conditions?.condition_value || "")?.split(",")?.map((item: string) => item?.trim())?.filter((item: string) => item?.length > 0) ?? [];
            case "condition switch":
                return condition_group ? true : false;
        }
    }

    const isOperatorWithEmptyValueSelected = () => {
        return operatorTypesWithEmptyValue?.includes((getValueOfFields("operator") as operatorType | null)?.operator_type_name?.toLowerCase() ?? "");
    }

    const checkIfSameIntentAlreadyConfigured = () => {
        const selected_node = nodes?.find((node: any) => node?.id === selectedActionIntent?.chatbot_step_id);
        if (!selected_node) return false;

        const selected_action = selected_node?.data?.find((action: any) => action?.chatbot_step_action_id === selectedActionIntent?.chatbot_step_action_id);
        if (!selected_action) return false;

        let matchingIntents = selected_action?.intents?.filter((int: any) => int.intent_id === payload?.intent_id) || [];
        if (!matchingIntents.length) return false;
        if(selectedIntent){
            matchingIntents =  matchingIntents?.filter((int: any) => JSON.stringify(int) != JSON.stringify(selectedIntent)) ?? [];
        }

        const payloadCond = payload?.condition_group?.custom_variable_conditions;

        const sameIntentExist = matchingIntents.some((int: any) => {
            const intCond = int?.condition_group?.custom_variable_conditions;

            return (
                int.flag_duplicate === payload.flag_duplicate &&
                (intCond?.chatbot_custom_variable_configuration_id ?? "") === (payloadCond?.chatbot_custom_variable_configuration_id ?? "")&&
                (intCond?.operator_type_id ?? "") === (payloadCond?.operator_type_id ?? "") &&
                (intCond?.condition_value ?? "") === (payloadCond?.condition_value ?? "")
            );
        }); 
        if(sameIntentExist){
            if(!flagSameIntentExist) setFlagSameIntentExist(true);
        } else {
            if(flagSameIntentExist) setFlagSameIntentExist(false);
        }
        return sameIntentExist;
    };

    const checkDisableSaveBtn = () => {
        if(!payload?.intent_id || !payload?.intent_name){
            return true;
        }

        if(checkIfSameIntentAlreadyConfigured()){
            return true;
        }

        if(!payload?.condition_group){
            return false;
        }

        return checkConditionValidation(payload?.condition_group?.custom_variable_conditions);
    }
    
    const onClickOfSaveBtn = () => {
        const updated_nodes = nodes?.map((node: any) => {
            if(node?.id == selectedActionIntent?.chatbot_step_id){
                return {
                    ...node, 
                    data: node?.data?.map((action: any) => {
                        if(action?.chatbot_step_action_id == selectedActionIntent?.chatbot_step_action_id){
                            return {
                                ...action, 
                                intents: selectedIntent ? 
                                    action?.intents?.map((int: intentConfigurationPayload) => {
                                        if(int?.intent_id == selectedIntent?.intent_id 
                                            && int?.flag_duplicate == selectedIntent?.flag_duplicate 
                                            && (int?.condition_group?.condition_group_id ?? "") == (selectedIntent?.condition_group?.condition_group_id ?? "")
                                            && (int?.chatbot_custom_variable_configuration_id ?? "") == (selectedIntent?.chatbot_custom_variable_configuration_id ?? "")
                                        ){
                                            return payload;
                                        }
                                        return int;
                                    })
                                    : 
                                    [...action?.intents, payload],
                            }
                        }
                        return action;
                    })
                }
            }
            return node;
        })
        setNodes(updated_nodes);

        onBlurOfFallBackOfBtnVar(updated_nodes, currentActiveNodeConfig, selectedActionIntent?.chatbot_step_action_id,
            {
                ...selectedActionIntent?.action_data,
            },
            {
                updateType: "editExistingStepAction"
            }
        ); 

        setFlagIntentPopup(false);
    }

    const onBlurOfFreeSoloAutoCompleteTextField = () => {
        if(typedConditionValue.trim()?.length > 0){
            const currentVal = getValueOfFields("freesolo value") as string[];
            if(!currentVal.find((val: string) => val == typedConditionValue?.trim())){
                const newVal = [...currentVal, typedConditionValue.trim()];
                onChangeOfFields({ type: "value", value: newVal?.map((item) => item?.trim())?.filter((item) => item.length > 0)?.join(", ") ?? "" })
                setTypedConditionValue("");
            }
        }
    }

    const renderFormControlLabelRadioBtn = (label: string, value: boolean) => {
        return <FormControlLabel className={globalStyles.radioLabelStyle} value={value} disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} control={<Radio className={globalStyles.radioButton} />} label={label} />;
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Typography className={`${style.popupTitleTypography} ${globalStyles.textCenter}`}>Configure Intent</Typography>
                        <Divider className={style.popupTitleDivider} /> 
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={2}>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Grid container className={`${globalStyles.displayFlex} ${globalStyles.justifyContentSpaceBetween}`}>
                                                <Grid item>
                                                    <Typography className={workflowCreateStyles.createWorkflowLabelStyle}>
                                                        Intent  <Required />
                                                    </Typography>
                                                </Grid>
                                                <GlobalTooltip
                                                    placement='top'
                                                    title='Fetch the latest intent list'
                                                >
                                                    <Grid item onClick={() => getAnalyticsIntentApi()}>
                                                        <RefreshIcon className={`${globalStyles.primaryColor} ${globalStyles.clickable}`} />
                                                    </Grid>
                                                </GlobalTooltip>
                                            </Grid>
                                        </Grid> 
                                        <Grid item xs={12}>
                                            <HierarchicalIntentAutocomplete
                                                payload={payload}
                                                setPayload={setPayload}
                                                selectedIntent={selectedIntent} 
                                                setFlagSameIntentExist={setFlagSameIntentExist}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Grid container className={globalStyles.displayFlex} gap={1}>
                                                <Grid item>
                                                    <Typography className={workflowCreateStyles.createWorkflowLabelStyle}>Trigger Condition</Typography>
                                                </Grid>
                                                <Grid item>
                                                    <PrimaryIOSSwitch
                                                        className={workflowCreateStyles.intentConditionSwitch}
                                                        checked={getValueOfFields("condition switch") as boolean}
                                                        onChange={(e) => onChangeOfFields({ type: "condition switch", value: e.target.checked })}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {getValueOfFields("condition switch") && 
                                            <>
                                                <Grid item xs={12}>
                                                    <Grid container gap={1} flexWrap={"nowrap"}>
                                                        <Grid item xs={isOperatorWithEmptyValueSelected() ? 6 : 4.5}>
                                                            <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                                                <Grid item>
                                                                    <Typography className={style.popupFieldTypography}>Variable <Required /></Typography>
                                                                </Grid>
                                                                <Grid>
                                                                    <Autocomplete
                                                                        className={`${style.contactFilterDropdownsInPopup}`}
                                                                        options={customVariableList?.custom_variable_data || []}
                                                                        getOptionLabel={(option) => option.chatbot_custom_variable_name}
                                                                        value={getValueOfFields("variable") as customVariableDataInterface | null}
                                                                        onChange={(_, value: customVariableDataInterface | null) => onChangeOfFields({ type: "variable", value: value })}
                                                                        renderInput={(params) => <TextField {...params} placeholder='Select Variable' />} 
                                                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>  
                                                        
                                                        <Grid item xs={isOperatorWithEmptyValueSelected() ? 6 : 3}>
                                                            <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                                                <Grid item>
                                                                    <Typography className={style.popupFieldTypography}>Operator <Required /></Typography>
                                                                </Grid>
                                                                <Grid>
                                                                    <Autocomplete
                                                                        className={`${style.contactFilterDropdownsInPopup}`}
                                                                        options={operatorList?.filter((operator) => operator.is_active) || []}
                                                                        getOptionLabel={(option) => option.operator_type_name}
                                                                        value={getValueOfFields("operator") as operatorType | null}
                                                                        onChange={(_, value: operatorType | null) => { onChangeOfFields({ type: "operator", value: value })}}
                                                                        renderInput={(params) => <TextField {...params} placeholder='Operator' />}
                                                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid> 

                                                        {!isOperatorWithEmptyValueSelected() && 
                                                            <Grid item xs={4}>
                                                                <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                                                    <Grid item>
                                                                        <Typography className={style.popupFieldTypography}>Value <Required /></Typography>
                                                                    </Grid>
                                                                    <Grid>
                                                                        {(getValueOfFields("operator") as operatorType | null)?.operator_type_name?.toLowerCase() == "contains in array" ?
                                                                            <Autocomplete   
                                                                                className={`${waCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${waCampaignStyles.actionAutoComplete} ${waCampaignStyles.actionUserReplyAutoComplete} ${workflowCreateStyles.triggerValueFreeSolo} ${workflowCreateStyles.conditionValueFreeSolo}`}
                                                                                freeSolo
                                                                                options={[]}
                                                                                multiple
                                                                                value={getValueOfFields("freesolo value") as string[]}
                                                                                inputValue={typedConditionValue} 
                                                                                onInputChange={(e, val) => setTypedConditionValue(val)}
                                                                                renderTags={(value, getTagProps) =>
                                                                                    value.map((option, index) => (
                                                                                        <Chip
                                                                                            label={option}
                                                                                            deleteIcon={<CloseIcon />}
                                                                                            {...getTagProps({ index })}
                                                                                            className={workflowCreateStyles.containsInArrayFieldChip}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                                onChange={(e, newValue) => { 
                                                                                    const filtered = newValue.filter((val) => typeof val === "string" && val.trim().length > 0);
                                                                                    onChangeOfFields({ type: "value", value: filtered?.map((item) => item?.trim())?.filter((item) => item.length > 0)?.join(", ") ?? "" })
                                                                                }} 
                                                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                                renderInput={params => {
                                                                                    const { InputProps, ...restParams } = params;
                                                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                                                    return (
                                                                                        <TextField
                                                                                            {...restParams}
                                                                                            placeholder='Enter Value' 
                                                                                            onBlur={() => onBlurOfFreeSoloAutoCompleteTextField()}
                                                                                            InputProps={{
                                                                                                ...restInputProps,
                                                                                                startAdornment: (
                                                                                                    <div className={waCampaignStyles.renderInputDivOfUserReplyOfAction}>
                                                                                                        {startAdornment}
                                                                                                    </div>
                                                                                                ),
                                                                                            }}
                                                                                        />
                                                                                    );
                                                                                }}
                                                                            />
                                                                            :
                                                                            <textarea
                                                                                value={getValueOfFields("value") as string}
                                                                                onChange={(e) => {
                                                                                    onChangeOfFields({ type: "value", value: e.target.value })
                                                                                }}
                                                                                placeholder="Enter Value"
                                                                                className={`${textAreaStyles.templateGlobalTextarea} ${workflowCreateStyles.conditionValueTextArea}`} 
                                                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                            />
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={workflowCreateStyles.createWorkflowLabelStyle}>
                                                Save Additional Information
                                            </Typography>
                                        </Grid> 
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${style.contactFilterDropdownsInPopup} ${workflowCreateStyles.saveAdditionInfoAutoComplete}`}
                                                options={customVariableList?.custom_variable_data || []}
                                                getOptionLabel={(option) => option.chatbot_custom_variable_name}
                                                value={getValueOfFields("save additional info") as customVariableDataInterface | null}
                                                onChange={(_, value: customVariableDataInterface | null) => onChangeOfFields({ type: "save additional info", value: value })}
                                                renderInput={(params) => <TextField {...params} placeholder='Select Variable' />} 
                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={workflowCreateStyles.createWorkflowLabelStyle}>Flag Duplicate <Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    defaultValue=""
                                                    name="radio-buttons-group"
                                                    value={getValueOfFields("flag duplicate") as boolean}
                                                    onChange={(event) => onChangeOfFields({ type: "flag duplicate", value: event.target.value })}
                                                >
                                                    {renderFormControlLabelRadioBtn("True", true)}
                                                    {renderFormControlLabelRadioBtn("False", false)}
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {flagSameIntentExist && 
                                    <Grid item xs={12}>
                                        <Typography className={workflowCreateStyles.sameIntentExistTypography}>
                                            An intent with the same configuration already exists.
                                        </Typography>
                                    </Grid>
                                }

                                <Grid item className={globalStyles.fullwidth} xs={12}>
                                    <Grid container gap={"12px"} mt={2} mb={3} justifyContent={"center"} alignItems={"center"}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Cancel"
                                                className='borderedButtonStyle'
                                                sx={{ width: "120px" }}
                                                onClick={() => setFlagIntentPopup(false)}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Save"
                                                className='primaryButtonStyle'
                                                sx={{ width: "120px" }} 
                                                disabled={checkDisableSaveBtn()} 
                                                onClick={() => onClickOfSaveBtn()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default IntentConfigurationPopup